module.exports = "/assets/48a981e93cf3393f9204b940ff806527.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ZH.png
// module id = 3181
// module chunks = 0